module.exports = __webpack_public_path__ + "static/media/background-desk.29d86a0f.jpg";